<template>
    <div>
        <label v-if="quotes.length" for="services">{{ $t('Available services') }}</label>
        <fieldset id="services">
            <div class="form-row">
                <div class="form-group col-12">
                    <div class="input-group" v-for="quote in quotes">
                        <div class="input-group-prepend">
                            <div class="input-group-text">
                                <input :id="'service' + quote.service.id" v-model="serviceId" :aria-label="renderQuote(quote)" type="radio" :value="quote.service.id" @change="updateQuote">
                            </div>
                        </div>
                        <div class="form-control">
                            <label class="form-check-label" :for="'service' + quote.service.id">{{ renderQuote(quote) }}</label>
                        </div>
                    </div>
                </div>
            </div>
        </fieldset>
        <div class="alert alert-info" v-if="quote && !quote.fare.price">
            <i class="fa fa-info mr-2"></i>
            {{ $t('This is a manual shipment!') }}
            {{ $t('Please get in touch with') }}
            <a href="mailto:info@foundspot.com">info@foundspot.com</a>
        </div>
        <div class="alert alert-danger" v-if="!quotes.length">
            <i class="fa fa-exclamation-circle mr-2"></i>
            {{ $t('There are no available services for the selected origin and destination!') }}
            {{ $t('Please get in touch with') }}
            <a href="mailto:info@foundspot.com">info@foundspot.com</a>
        </div>
    </div>
</template>

<script>
export default {
    name: "ServiceForm",
    props: {
        showPrice: {type: Boolean},
    },
    computed: {
        parcel: function () {
            return this.$store.state.order.parcel;
        },
        quotes: function () {
            return this.$store.state.order.quote.quotes;
        },
        senderZone() {
            return this.$store.getters['order/sender/zone'];
        },
        recipientZone() {
            return this.$store.getters['order/recipient/zone'];
        },
        weight() {
            return this.parcel.weight;
        },
        height() {
            return this.parcel.height;
        },
        width() {
            return this.parcel.width;
        },
        length() {
            return this.parcel.length;
        },
        subcategory() {
            return this.parcel.subcategory;
        },
        quote() {
            return this.quotes.filter(quote => quote.service.id === this.serviceId).shift();
        },
    },
    data() {
        return {
            serviceId: this.$store.state.order.quote?.service?.id,
        }
    },
    watch: {
        senderZone() {
            this.loadQuotes();
        },
        recipientZone() {
            this.loadQuotes();
        },
        weight() {
            this.loadQuotes();
        },
        height() {
            this.loadQuotes();
        },
        width() {
            this.loadQuotes();
        },
        length() {
            this.loadQuotes();
        },
        subcategory() {
            this.loadQuotes();
        },
    },
    methods: {
        // TODO add debounce
        loadQuotes() {
            if (this.senderZone && this.recipientZone && this.weight && this.height && this.width && this.length && this.subcategory) {
                this.$store.dispatch('order/quote/searchQuotes', {
                    origin: this.senderZone.id,
                    destination: this.recipientZone.id,
                    weight: this.weight,
                    height: this.height,
                    width: this.width,
                    length: this.length,
                    subcategory: this.subcategory.id,
                });
            }
        },
        updateQuote() {
            this.$store.commit('order/quote/setQuote', this.quote);
        },
        renderQuote(quote) {
            let price = this.showPrice && quote.fare.price ? this.formatPrice(quote.fare.price) : '';
            let transit = quote.transit ? `(${quote.transit.duration})` : '';

            return `${price} ${quote.service.name} ${transit}`;
        },
        formatPrice(price) {
            return Intl.NumberFormat(
                document.body.dataset.locale,
                {style: 'currency', currency: process.env.MIX_SALES_CURRENCY}
            ).format(price + price * process.env.MIX_SALES_VAT);
        },
    },
}
</script>
